import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    reference: {
      label: {
        id: 'properties.reference',
        defaultMessage: 'Reference',
        description: 'label of the form field reference',
      },
    },
    description: {
      label: {
        id: 'properties.description',
        defaultMessage: 'Description',
        description: 'label of the form field description',
      },
    },
    amount: {
      label: {
        id: 'properties.amount',
        defaultMessage: 'Amount',
        description: 'label of the form field amount',
      },
    },
    amountDue: {
      label: {
        id: 'properties.amountDue',
        defaultMessage: 'Amount due',
        description: 'label of the form field amount due',
      },
    },
    amountPaid: {
      label: {
        id: 'properties.amountPaid',
        defaultMessage: 'Amount paid',
        description: 'label of the form field amount paid',
      },
    },
    isPaid: {
      label: {
        id: 'properties.isPaid',
        defaultMessage: 'Is paid',
        description: 'label of the form field is paid',
      },
    },
    currency: {
      label: {
        id: 'properties.currency',
        defaultMessage: 'Currency',
        description: 'label of the form field currency',
      },
    },
    returnUrl: {
      label: {
        id: 'properties.returnUrl',
        defaultMessage: 'Return URL',
        description: 'label of the form field return url',
      },
    },
    webhookUrl: {
      label: {
        id: 'properties.webhookUrl',
        defaultMessage: 'Webhook URL',
        description: 'label of the form field webhook url',
      },
    },
    secret: {
      label: {
        id: 'properties.secret',
        defaultMessage: 'Secret',
        description: 'label of the form field secret',
      },
      tooltip: {
        id: 'properties.secretTooltip',
        defaultMessage: 'Copied secret',
        description: 'label of the tooltip for copying',
      },
      button: {
        id: 'properties.secretButton',
        defaultMessage: 'Copy secret',
        description: 'label of the button for copying',
      },
    },
    createdAt: {
      label: {
        id: 'properties.createdAt',
        defaultMessage: 'Created at',
        description: 'label of the form field created at',
      },
    },
    updatedAt: {
      label: {
        id: 'properties.updatedAt',
        defaultMessage: 'Updated at',
        description: 'label of the form field updated at',
      },
    },
  },
};

export default defineMessages(translations);
